import { useState, useEffect } from 'react';
import React from 'react';
import { Button, Grid, Icon } from 'semantic-ui-react';
import '../stylesheets/AboutRxMill.less';

const AboutRxMill = ({ setAboutRxMillState }) => {

    const closePopup = () => {
        setAboutRxMillState(false)
    }

    return (
        <>
            <div id="about-rx-mill-overlay">
                    <Grid padded centered verticalAlign='middle' columns={1}
                        style={{ height: '100%' }}>
                        <Grid.Column className="about-mill">
                            <Icon className="about-rx-mill-close" floated="right" name="times circle" size="big" inverted onClick={closePopup}></Icon>
                            <h1 id='showroom-story-heading'>
                                Welcome to the future mill
                            </h1>
                            <p className='showroom-story'>
                                Representing a vision of a future mill, this virtual mill takes a look into the future of veneer, plywood, and LVL production.
                            </p>
                            <p className='showroom-story'>
                                Highlighting the technologies, concepts, and solutions that lead the way to the future of your value creation.
                            </p>
                            <p className='showroom-story'>
                                Discover valuable and insightful material by exploring themed hotspots or let your imagination roam by “grabbing” the screen and looking at all the details of the virtual mill.
                            </p>
                            <p className='showroom-story'>
                                So sit back, relax and explore the future of your veneer-based business.
                            </p>
                            <br/>
                            <Button className="enter-showroom" size='massive' onClick={closePopup}>Explore Virtual Mill</Button>
                        </Grid.Column>
                    </Grid>
            </div>
        </>
    )
}

export default AboutRxMill;